import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import useBasket from '@/b2c/basket/useBasket';
import QuantityField from '@/shared/checkout/basket/ui/QuantityField.vue';
import { ref, Ref, toRef, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemQuantity',
  props: {
    id: null,
    quantity: null,
    multiplier: null,
    max: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { id: number, quantity: number, multiplier: number, max: number }



const { updateItemQuantity, pending } = useBasket();
const internalQuantity: Ref<number> = ref(0);
const externalQuantity: Ref<number> = toRef(props, 'quantity');

watch(externalQuantity, quantity => {
    if (quantity !== internalQuantity.value) {
        internalQuantity.value = quantity;
    }
}, { immediate: true });

const handleChange = ({ quantity }): void => {
    updateItemQuantity(props.id, { quantity, delta: false });
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(QuantityField, {
    id: __props.id,
    modelValue: internalQuantity.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalQuantity).value = $event)),
    multiplier: __props.multiplier,
    pending: _unref(pending),
    max: __props.max,
    onChange: handleChange
  }, null, 8, ["id", "modelValue", "multiplier", "pending", "max"]))
}
}

})